export type WebsiteTemplateOption = {
  key: string;
  name: string;
  description: string;
  accentColor: string;
  badge: string;
  layoutLabel: string;
  previewBackground: string;
  previewSurface: string;
  previewAccent: string;
};

export const DEFAULT_WEBSITE_TEMPLATE_KEY = "template-1";

export const WEBSITE_TEMPLATE_OPTIONS: WebsiteTemplateOption[] = [
  {
    key: "template-1",
    name: "Default Template",
    description: "The standard AFH Hub website layout with the familiar default editor structure and balanced sections.",
    accentColor: "#0f6cbd",
    badge: "Default",
    layoutLabel: "Standard editor layout",
    previewBackground: "linear-gradient(135deg, #dbeafe 0%, #fff7ed 100%)",
    previewSurface: "#ffffff",
    previewAccent: "#f59e0b",
  },
  {
    key: "template-5",
    name: "Premium Presence",
    description: "A richer, elevated layout for providers who want a more premium and established brand presentation.",
    accentColor: "#d61f69",
    badge: "Premium",
    layoutLabel: "High-contrast premium split",
    previewBackground: "linear-gradient(135deg, #ffe4ef 0%, #fffafc 100%)",
    previewSurface: "#fff1f7",
    previewAccent: "#fb7185",
  },
] ;

export const getWebsiteTemplateOption = (templateKey?: string | null) => {
  return WEBSITE_TEMPLATE_OPTIONS.find((option) => option.key === templateKey) || WEBSITE_TEMPLATE_OPTIONS[0];
};
